var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.styleType}Text`]},[_c('b-alert',{attrs:{"id":"explanatoryText","show":""}},[_vm._v(_vm._s(_vm.$t(_vm.value)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }